import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import { APP } from "../../../Definition";
import {
  Context,
  fetchTeachers,
  newTeacherPath,
  editTeacherPath,
  bulkRegisterTeachersPath,
  fetchClasses,
  masqueradeTeacher,
  MASQUERADE_TEACHER_SUCCESS_MESSAGE,
  clearSuccessMessage,
  clearErrorMessage,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import TeacherList from "../../../templates/manager/TeacherList";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const { currentYear } = useCurrentYear();
  const [proxyLoginApp, setProxyLoginApp] =
    React.useState<typeof APP[keyof typeof APP]>();

  React.useEffect(() => {
    dispatch(fetchTeachers());
    dispatch(fetchClasses(currentYear));
  }, [dispatch, currentYear]);

  const toBuildNewTeacher = React.useCallback(
    () => history.push(newTeacherPath),
    [history],
  );
  const toBuildTeacher = React.useCallback(
    id => {
      history.push(`${editTeacherPath}/${id}`);
    },
    [history],
  );

  const toBulkRegisterTeachers = React.useCallback(() => {
    history.push(bulkRegisterTeachersPath);
  }, [history]);

  const dlpLoginFunc = React.useCallback(
    (id: number) => {
      setProxyLoginApp(APP["dlp"]);
      dispatch(peep(masqueradeTeacher(id, APP["dlp"])));
    },
    [dispatch, peep],
  );

  const gearLoginFunc = React.useCallback(
    (id: number) => {
      setProxyLoginApp(APP["g4s"]);
      dispatch(peep(masqueradeTeacher(id, APP["g4s"])));
    },
    [dispatch, peep],
  );

  const handleAppUrl = React.useCallback(
    (app: typeof APP[keyof typeof APP]) => {
      const appURLs = {
        [APP["dlp"]]: process.env.REACT_APP_TEACHER_DLP_URL,
        [APP["g4s"]]: process.env.REACT_APP_TEACHER_APP_URL,
      };
      return appURLs[app];
    },
    [],
  );

  React.useEffect(() => {
    if (state.success_message === MASQUERADE_TEACHER_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      const appUrl = proxyLoginApp ? handleAppUrl(proxyLoginApp) : null;
      appUrl &&
        window.open(
          `${appUrl}?session_id=${state.temporary_session_id}`,
          "_blank",
        );
    }
  }, [
    dispatch,
    state.success_message,
    state.success_result,
    state.temporary_session_id,
    handleAppUrl,
    proxyLoginApp,
  ]);

  React.useEffect(() => {
    return () => dispatch(clearErrorMessage());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb currentTitle={titles.teachers} />
      <TeacherList
        title={titles.teachers}
        calling={calling}
        toBuildNewTeacher={toBuildNewTeacher}
        toBuildTeacher={toBuildTeacher}
        toBulkRegisterTeachers={toBulkRegisterTeachers}
        teachers={state.teachers}
        classes={state.classes}
        dlpLogin={dlpLoginFunc}
        gearLogin={
          !!state.isMasqueradeByAdmin || state.manager!.school!.g4s_enabled
            ? gearLoginFunc
            : undefined
        }
      />
    </div>
  );
};
